
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import Menu from '@/components/Menu.vue'
import { ScreenInfo } from '@/types'

export default defineComponent({
  name: 'Header',

  components: {
    Menu,
  },

  props: {
    screenInfo: {
      type: Object as PropType<ScreenInfo>,
      default: undefined,
    },
  },

  setup () {
    const router = useRouter()
    const path = computed(() => router.currentRoute.value.name)
    return {
      router, path,
    }
  },
})
